<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem; margin-bottom: 0!important;">
		<div class="py-2 border-bottom d-flex align-items-center">
			<el-button type="primary" size="mini" icon="el-icon-search">查询</el-button>
			<el-button type="primary" size="mini" @click="openModel('qtwl')" icon="el-icon-plus">添加</el-button>
		</div>
		<div>
			<el-table :data="qtwlList" style="width: 100%" size="mini"	row-key="id" :tree-props="{ children: 'child', hasChildren: 'hasChildren' }"  @current-change="handleCurrentChange">
				<el-table-column width="80" align="center">
					<template slot="header" slot-scope="scope">编号</template>
					<template slot-scope="scope">{{scope.row.id}}</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">物流名称</template>
					<template slot-scope="scope">{{scope.row.mc}}</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">物流编码</template>
					<template slot-scope="scope">{{scope.row.wlbm}}</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">联系人</template>
					<template slot-scope="scope">{{scope.row.lxr}}</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">联系电话</template>
					<template slot-scope="scope">{{scope.row.lxdh}}</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">地区</template>
					<template slot-scope="scope">{{scope.row.dq}}</template>
				</el-table-column>
				<el-table-column >
					<template slot="header" slot-scope="scope">详细地址</template>
					<template slot-scope="scope">{{scope.row.xxdz}}</template>
				</el-table-column>
				<el-table-column align="center" fixed="right" width="80">
					<template slot="header" slot-scope="scope">排序编号</template>
					<template slot-scope="scope">{{scope.row.id}}</template>
				</el-table-column>
				<el-table-column align="center" fixed="right" width="290">
					<template slot="header" slot-scope="scope">操作</template>
					<template slot-scope="scope">
						<!-- <el-button type="primary" size="mini" @click="openModel('qtwl',scope.row)">查看</el-button> -->
						<el-button type="primary" size="mini" @click="openModel('qtwl',scope.row)">编辑</el-button>
						<el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
					</template>
				</el-table-column>
				
			</el-table>
		</div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;">
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper" 	:total="page.total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange"></el-pagination>
			</div>
		</el-footer>
		<el-dialog title="类别详情" :visible.sync="createModel" top="10vh">
			<!-- 表单内容 -->
			<div style="width: 100%;margin-top: 20px;" class="d-flex">
				<el-form v-if="preUrl ==='qtwl' " ref="form" :model="form.qtwl" label-width="80px" style="width: 50%;">
					<el-form-item label="物流名称">
						<el-input v-model="form.qtwl.mc" size="mini" style="width: 95%;"></el-input>
					</el-form-item>
					<el-form-item label="物流编码">
						<el-input v-model="form.qtwl.wlbm" size="mini" style="width: 95%;"></el-input>
					</el-form-item>
					<el-form-item label="备注">
						<el-input v-model="form.qtwl.desc" size="mini" style="width: 95%;"></el-input>
					</el-form-item>
				</el-form>
				<el-form v-if="preUrl ==='qtwl' " ref="form" :model="form.qtwl" label-width="80px" style="width: 50%;">
					<el-form-item label="联系人">
						<el-input v-model="form.qtwl.lxr" size="mini" style="width: 95%;"></el-input>
					</el-form-item>
					<el-form-item label="联系电话">
						<el-input v-model="form.qtwl.lxdh" size="mini" style="width: 95%;"></el-input>
					</el-form-item>
					<el-form-item label="地区">
						<el-input v-model="form.qtwl.dq" size="mini" style="width: 95%;"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div style="width: 100%;">
				<el-form v-if="preUrl ==='qtwl' " ref="form" :model="form.qtwl" label-width="80px" style="width: 100%;">
					<el-form-item label="详细地址">
						<el-input v-model="form.qtwl.xxdz" size="mini" style="width: 98%;"></el-input>
					</el-form-item>
				</el-form>
				
			</div>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	data() {
		return {
			form: {
				qtwl: {
				},
			},
			createModel: false,
			dialogType: "qtwl",
			preUrl: "qtwl", //api
			dialogId: 0,
			qtwlList:[]
		};
		
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	methods: {
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}`
		},
		// 处理列表结果
		getListResult(e) {
			this.qtwlList = e.list
			console.log(this.qtwlList)
		},
		openModel(type, item = false) {
			// 初始化表单
			switch (type) {
				// 初始化添加管理员
				case 'qtwl':
					if (!item) {
						this.form.qtwl = {
							id:'',
							mc: "",
							desc: "",
							wlbm: "",
							lxr:"",
							lxdh:"",
							dq:"",
							xxdz:""
						}
						this.dialogId = 0
					} else {
						this.form.qtwl = {
							mc: item.mc,
							desc: item.desc,
							wlbm: item.wlbm,
							dq: item.dq,
							lxr: item.lxr,
							lxdh: item.lxdh,
							xxdz: item.xxdz,
						}
						this.dialogId = item.id
					}
					break;
			}
			// 打开dialog
			this.createModel = true;
		},
		submit() {
			let f = this.form.qtwl
			let e = {
				mc: f.mc,
				desc: f.desc,
				wlbm: f.wlbm,
				dq: f.dq,
				lxr: f.lxr,
				lxdh: f.lxdh,
				xxdz: f.xxdz,
				cjr:this.user.id
			}
			this.addOrEdit(e, this.dialogId);
			this.createModel = false;
		},
		handleCurrentChange(val) {
			this.currentRow = val;
		}
	}
};
</script>

<style></style>
